import React from 'react';

const OrderTotalSkeleton = () => (
    <div className="my-3 animate-pulse">
      <div className="glass-surface p-4 rounded-3xl">
        <div className="flex flex-col">
          <div className="flex justify-between items-center mb-2">
            <div className="h-4 w-24 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
            <div className="h-4 w-28 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
          </div>
          <div className="flex justify-between items-center mb-2">
            <div className="h-4 w-40 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
            <div className="h-4 w-24 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
          </div>
          <div className="flex justify-between items-center mb-2">
            <div className="h-4 w-48 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
            <div className="h-4 w-24 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
          </div>
          <div className="flex justify-between items-center mt-4">
            <div className="h-5 w-40 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
            <div className="h-6 w-32 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
          </div>
        </div>
      </div>
    </div>
);

export default OrderTotalSkeleton;
